import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { categoriesAPI } from '../services/api';
import { resolveTagLink, useFilledCatalog } from '../services/tagLinks';

let categoriesCache = null;

// Popular-search tags: link to an indexable category/subcategory page when one matches, else internal search (nofollow)
const TagLinks = ({ tags, title, excludePath, testIdPrefix, sectionTestId }) => {
  const filled = useFilledCatalog();
  const [categories, setCategories] = useState(categoriesCache || []);
  useEffect(() => {
    if (categoriesCache) return;
    categoriesAPI.getAll().then((l) => { categoriesCache = l; setCategories(l); }).catch(() => {});
  }, []);
  if (!tags?.length) return null;
  return (
    <section className="mt-6" data-testid={sectionTestId}>
      <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3 flex items-center gap-2"><Search size={14} /> {title}</h2>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => {
          const hit = resolveTagLink(tag, categories, filled, excludePath);
          const cls = 'text-sm px-3 py-1.5 rounded-full bg-white border border-gray-200 text-gray-700 hover:border-orange-400 hover:text-orange-600 transition-colors';
          return hit
            ? <Link key={tag} to={hit.path} title={hit.label} data-testid={`${testIdPrefix}-${tag}`} data-target="category" className={cls}>{tag}</Link>
            : <Link key={tag} to={`/recherche?q=${encodeURIComponent(tag)}`} rel="nofollow" data-testid={`${testIdPrefix}-${tag}`} data-target="search" className={cls}>{tag}</Link>;
        })}
      </div>
    </section>
  );
};

export default TagLinks;
